import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, filter, map, of, take, tap } from 'rxjs';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { getIsNotNullable } from '../nullable-utils';
import { ProjectService } from '../services/project.service';

export const projectsResolver: ResolveFn<Observable<boolean>> = (
  currentRoute: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
) => {
  const projectService = inject(ProjectService);
  const navigationService = inject(NavigationService);
  const hasProjectIdInRoute = getIsNotNullable(currentRoute.firstChild?.paramMap.get('projectId'));

  if (!hasProjectIdInRoute) {
    return toObservable(projectService.projectStore.isLoading).pipe(
      filter(val => !val),
      take(1),
      tap(() => navigationService.navigateToDashboard(projectService.currentProjectId())),
      map(() => true),
    );
  }

  return of(true);
};
